import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Bannerbgimg } from "assets/images";
import "./CityWisePages.scss";
import InstituteToppers from "components/institute-toppers/InstituteToppers";
import FacultiesList from "components/faculties-list/FacultiesList";
import CampusGallery from "components/campus-photos/CampusGallery";
import Testimonials from "components/testimonial/Testimonial";
import ContactusForm from "components/contactus-form/Contactus-form";
import FAQ from "components/FAQs/FAQs";
import { centerBasedLandingPage, cityBasedLandingPage } from "services/center";
import CourseDetailSkeleton from "components/skeleton/CourseDetailSkeleton";
import YoutubeVideo from "components/video-player/YoutubeVideo";
import {
  errorResponse,
  failResponse,
  normalDecryptData,
  normalEncryptData,
} from "config/config";
import CenterSectionDetails from "components/center-section-details/CenterSectionDetails";
import CenterMap from "pages/center-landing/section/CenterMap";
import UpcomingCourses from "pages/center-landing/section/UpcomingCourses";
import UpcomingCoursesCityWise from "./UpcomingCoursesCityWise";
import NewsSection from "./NewsSection";
import NotFound from "pages/not-found/NotFound";
import CityYoutubeVideo from "components/video-player/CityYoutubeVideo";

const CityWisePage = () => {
  const { city } = useParams();
  const [loading, setLoading] = useState(false);
  const [cityData, setCityData] = useState({});
  const [examTypes, setExamTypes] = useState([]);
  const [citysections, setcitysections] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [centerSections, setCenterSections] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [toppers, setToppers] = useState([]);
  const [faculties, setFaculties] = useState([]);
  const [allCenters, setAllCenters] = useState([]);
  const [type, settype] = useState("center");
  const [showFull, setShowFull] = useState(false);

  const navigate = useNavigate();

  // --------------- getting all required masters data ----------------//
  React.useLayoutEffect(() => {
    const getCentersData = async () => {
      try {
        setLoading(true);
        // Proceed with fetching data based on the determined mainId
        const res = await cityBasedLandingPage({ city: city });

        if (res.code === 200) {
          const {
            cityData,
            testimonials,
            examTypes,
            citysections
          } = res.data;

          setCityData(cityData);
          setExamTypes(examTypes);
          setTestimonials(
            (testimonials || []).map((item) => ({
              id: item.id,
              ...item.citytestimonials
            }))
          );

          setcitysections(citysections)
          setLoading(false);

        } else {
          failResponse(res);
          setLoading(false);
        }

      } catch (err) {
        errorResponse(err);
        setLoading(false);
      }
    };


    // calls all the master functions
    getCentersData();
    // eslint-disable-next-line
  }, [city]);



  return (
    <>
      {!loading && (
        <section className="city-landingpage">
          {cityData ? (
            <>
              <div
                className="city-landingpage_banner spacing"
                style={{ background: `#ffeded` }}
              >
                <div className="city-container">
                  <div className="city-content">
                    <h1>Welcome to Shubhra Ranjan IAS Study, {cityData?.city}</h1>
                    <div className="city-subheading">
                      <p
                        className={showFull ? "full-text" : "truncate-text"}
                        dangerouslySetInnerHTML={{ __html: cityData?.subheading }}
                      />
                      {cityData?.subheading?.split(" ").length > 20 && (
                        <button
                          onClick={() => setShowFull(!showFull)}
                          className="read-more-btn-city"
                        >
                          {showFull ? "Read Less" : "Read More"}
                        </button>
                      )}
                    </div>

                  </div>
                  <div className="city-slider_section">
                    <CityYoutubeVideo src={cityData?.introductionVideoURL} />
                  </div>
                </div>
              </div>
              {/* <NewsSection news={cityData?.news} /> */}

              <UpcomingCoursesCityWise
                exam={examTypes}
                affiliatecenter={cityData?.CenterID}
                cityid={cityData?.id}
                phoneNumber={cityData?.Phone1}
                city={cityData?.City}
              />

              {/* <CenterSectionDetails sectionDetails={citysections} /> */}

              <Testimonials testimonials={testimonials} loading={loading} />


              <ContactusForm
                center={cityData?.city}
                address={cityData?.state?.center?.Address}
                centerId={cityData?.id}
                frompage={"citywisepage"}
                phone={cityData?.state?.center?.Phone1}
                sriasname={cityData?.state?.center?.CenterName}
              />

              {faqs.length > 0 && <FAQ loading={loading} faqs={faqs} />}

              {/* <CenterMap cityData={cityData} /> */}

              <div className="number_data spacing">
                <div className="container">
                  <div className="number_data_content">
                    <ul>
                      <li>
                        <h3>62,000 + </h3> <span>Students Tutored</span>
                      </li>
                      <li>
                        <h3>50 + </h3> <span>Courses Offered</span>
                      </li>
                      <li>
                        <h3>20 + </h3> <span>Experienced faculties</span>
                      </li>
                      <li>
                        <h3>8 </h3> <span>Regional Centers</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="city-container spacing">
              <NotFound />
            </div>
          )}
        </section>
      )}

      {loading && (
        <div className="course_detail_section">
          <CourseDetailSkeleton />
        </div>
      )}
    </>
  );


};

export default CityWisePage;
